<template>
  <div class="main-container">
    <div class="login-box">
      <div class="bg"></div>
      <div class="form-box">
        <div class="form-tab">
          <div class="logo">
            <img v-for="logo in logos" :src="logo" alt="" v-bind:key="logo" style="width: 120px" />
          </div>
          <h3 class="title">医学影像质控管理平台</h3>
          <!-- <div class="tab">
            <div class="tab-item" :class="activeTab === 'login' ? 'active' : ''" @click="activeTab = 'login'">登录</div>
            <div class="tab-item" :class="activeTab === 'register' ? 'active' : ''" @click="activeTab = 'register'">注册</div>
          </div> -->
          <div class="content">
            <div class="box login">
              <el-row class="login-container">
                <el-col :span="24" class="right-panel">
                  <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0" class="login-form" :size="'large'">
                    <div class="form-title">用户名</div>
                    <el-form-item prop="username">
                      <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <div class="form-title">密码</div>
                    <el-form-item prop="password">
                      <el-input v-model="loginForm.password" type="password" placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <el-row>
                      <el-col :span="12">
                        <el-checkbox v-model="loginForm.rememberMe"> 记住我 </el-checkbox>
                      </el-col>
                      <!-- <el-col :span="12" style="text-align: right; line-height: 40px">
                        <el-button type="primary" link> 忘记密码？点此找回 </el-button>
                      </el-col> -->
                    </el-row>
                    <el-form-item style="padding-top: 20px">
                      <el-button type="primary" :size="'large'" class="full-width-button" @click="handleLogin"> 登&nbsp;&nbsp;录 </el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <!-- <el-divider>
                <span style="color: #bdc1c5">其他登录方式</span>
              </el-divider>
              <el-row>
                <el-col :span="24">
                  <el-button size="large" class="full-width-button scan-qr" style="margin-top: 20px"> <img src="@/assets/wechat-fill.svg" alt="" style="height: 30px" />&nbsp;微信扫码登录 </el-button>
                </el-col>
              </el-row> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppFooter fixed variant="dark" />
  </div>
</template>
<script>
// import { nextTick } from "vue";
// import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import userService from "@/utils/userService";
import { usePermissionStore } from "@/store/permissionStore";
import { useConfigStore } from "@/store/configStore";
import { useInstitutionStore } from "@/store/institutionStore";
import AppFooter from "@/components/AppFooter.vue";
export default {
  name: "LoginView",
  components: { AppFooter },
  data() {
    return {
      activeTab: "login", // login | register
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
      },
      rules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      logos: [],
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          sessionStorage.clear();
          // 执行登录逻辑
          userService
            .login({
              username: this.loginForm.username,
              password: this.loginForm.password,
            })
            .then(async (res) => {
              if (res.code === 0) {
                ElMessage.success("登录成功");
                const permissionStore = usePermissionStore();
                const institutionStore = useInstitutionStore();
                permissionStore.resetAuthorization();
                institutionStore.setOptions([]);
                if (this.loginForm.rememberMe) {
                  localStorage.setItem("loginInfo", JSON.stringify(this.loginForm));
                } else {
                  localStorage.removeItem("loginInfo");
                  localStorage.removeItem("userInfo");
                  localStorage.removeItem("token");
                  localStorage.removeItem("ttl");
                }
                //将token存到local storage
                localStorage.setItem("token", res.data.token);
                //存储ttl, 登录后的24小时
                localStorage.setItem("ttl", new Date().getTime() + 24 * 60 * 60 * 1000);
                localStorage.setItem("userInfo", JSON.stringify(res.data));
                sessionStorage.setItem("userInfo", JSON.stringify(res.data));
                //设置cookie token
                document.cookie = `token=${res.data.token}`;
                permissionStore.setSuperAdmin(res.data.superAdmin);
                //如果是超管
                if (res.data.superAdmin) {
                  //设置store superAdmin = true
                  this.$router.push("/admin/dashboard");
                  return;
                } else {
                  await permissionStore.fetchPermissions(res.data.id);
                  // await this.fetchPermissions(res.data.id);
                  let firstPath = this.getFirstRoute();
                  console.log("firstPath", firstPath);
                  this.$router.push(firstPath);
                }
              } else {
                ElMessage.error(res.message);
              }
            })
            .catch((err) => {
              console.log("err", err);
              ElMessage.error("登录失败");
            });
        } else {
          return false;
        }
      });
    },
    getFirstRoute() {
      //获取全部路由
      let routes = this.$router.getRoutes();
      let path = "";
      //遍历路由，找到第一个有权限的路由
      for (let i = 0; i < routes.length; i++) {
        const meta = routes[i].meta;
        const permitted = meta?.anyRoles
          ? meta.anyRoles.some(code => usePermissionStore().hasPermission(code))
          : usePermissionStore().hasPermission(meta?.role);
        if (meta && permitted) {
          path = routes[i].path;
          if (routes[i].children && routes[i].children.length > 0) {
            for (let j = 0; j < routes[i].children.length; j++) {
              if (usePermissionStore().hasPermission(routes[i].children[j].meta.role)) {
                path = routes[i].children[j].path;
                break;
              }
            }
          }
          break;
        }
      }
      return path;
    },
    getLoginInfo() {
      let loginInfo = localStorage.getItem("loginInfo");
      if (loginInfo) {
        this.loginForm = JSON.parse(loginInfo);
      }
    },
  },
  created() {
    const configStore = useConfigStore();
    this.logos = configStore.logos;
    this.getLoginInfo();
  },
  mounted() {
    // nextTick(() => {});
  },
};
</script>
<style scoped lang="less">
.main-container {
  background-color: #000;
  min-height: 100vh;

  .login-box {
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;

    .bg {
      flex: 1;
      background: #100e2d url("~@/assets/login-bg.png") no-repeat center center;
      background-size: auto 100%;
      opacity: 0.45;
    }

    .form-box {
      flex: 1;
      background-color: rgba(255, 255, 255, 1);
      position: relative;

      .form-tab {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -65%);
        width: 460px;
        height: 600px;
        .logo {
          text-align: center;
          img:not(:first-child) {
            margin-left: 7px;
          }
        }
        .title {
          text-align: center;
          font-size: 32px;
          padding: 0px 0 0px 0;
          line-height: 48px;
          > div {
            font-size: 22px;
            color: #7a828b;
          }
        }

        .tab {
          display: flex;

          .tab-item {
            flex: 1;
            text-align: center;
            padding: 10px 0;
            cursor: pointer;
            border-bottom: #fff solid 2px;

            &:hover,
            &.active {
              color: #769bea;
              border-color: #769bea;
            }
          }
        }

        .content {
          padding: 20px 0;
          .form-title {
            font-size: 14px;
            color: #7a828b;
            line-height: 40px;
            font-weight: 800;
          }
          .scan-qr {
            box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
            color: #7a828b;
          }
        }
      }
    }
  }
}
</style>
